export const mockOpenDayData = {
  openDays: [
    {
      id: 1001,
      start_time: "2026-02-14T10:00:00",
      end_time: "2026-02-14T16:00:00",
      active: 1,
      type: "U",
      description: "Undergraduate Open Day (Mock)",
    },
  ],
  topicsByOpenDay: {
    "1001": [
      {
        id: 201,
        name: "Computer Science",
        programs: [
          {
            id: 301,
            open_day_id: 1001,
            start_time: "2026-02-14T10:00:00",
            end_time: "2026-02-14T10:45:00",
            title: "BSc Computer Science",
            description_short: "Overview of the BSc Computer Science programme.",
            description:
              "Meet staff and students to learn about modules, projects, and career paths.",
            room: "Lecture Theatre A",
            location: {
              title: "Main Building",
              campus: {
                title: "Cathays Park Campus",
              },
              website: "https://example.com",
              accessible: 1,
              bike_parking: 1,
            },
            programType: { type: "Talk" },
          },
          {
            id: 302,
            open_day_id: 1001,
            start_time: "2026-02-14T11:30:00",
            end_time: "2026-02-14T12:15:00",
            title: "Software Engineering Lab Tour",
            description_short: "Guided tour of our teaching labs.",
            room: "Lab 2.14",
            location: {
              title: "Tech Labs",
              campus: {
                title: "Cathays Park Campus",
              },
              website: "https://example.com",
              accessible: 0,
              bike_parking: 1,
            },
            programType: { type: "Tour" },
          },
        ],
      },
      {
        id: 202,
        name: "Business & Management",
        programs: [
          {
            id: 303,
            open_day_id: 1001,
            start_time: "2026-02-14T13:00:00",
            end_time: "2026-02-14T13:45:00",
            title: "Business School Q&A",
            description_short: "Ask current students about studying Business.",
            room: "Seminar Room 3",
            location: {
              title: "Business School",
              campus: {
                title: "Cathays Park Campus",
              },
              accessible: 1,
              bike_parking: 0,
            },
            programType: { type: "Advice" },
          },
        ],
      },
      {
        id: 203,
        name: "General Talks and Activities",
        programs: [
          {
            id: 304,
            open_day_id: 1001,
            start_time: "2026-02-14T09:00:00",
            end_time: "2026-02-14T09:40:00",
            title: "Why Study at Cardiff University?",
            description_short:
              "This talk will cover what makes Cardiff University such an exciting place to study.",
            description:
              "As Wales' only Russell Group university, Cardiff University has much to offer. From research excellence and on-going campus investment, to our capital city location and active Students' Union.",
            room: "Sir Stanley Thomas OBE Lecture Theatre",
            location: {
              title: "Centre for Student Life",
              campus: {
                title: "Cathays Park Campus",
              },
              website: "https://www.cardiff.ac.uk/",
              accessible: 1,
              bike_parking: 1,
            },
            programType: { type: "Talk" },
          },
          {
            id: 305,
            open_day_id: 1001,
            start_time: "2026-02-14T09:00:00",
            end_time: "2026-02-14T16:00:00",
            title: "Postgraduate Information Stand",
            description_short:
              "Meet the postgraduate team and current postgraduate students.",
            description:
              "Find out more about funding your master's degree and what it's like to study as a postgraduate student at Cardiff University.",
            room: "Ground floor",
            location: {
              title: "Centre for Student Life",
              campus: {
                title: "Cathays Park Campus",
              },
              website: "https://www.cardiff.ac.uk/",
              accessible: 1,
              bike_parking: 1,
            },
            programType: { type: "Advice" },
          },
          {
            id: 306,
            open_day_id: 1001,
            start_time: "2026-02-14T09:00:00",
            end_time: "2026-02-14T16:00:00",
            title: "University Libraries: Bute and Architecture Library",
            description_short: "Visit a selection of our libraries.",
            description:
              "University libraries are located close to academic schools. Visit the Bute and Architecture Library during the open day.",
            room: "Cathays Park Campus",
            location: {
              title: "Bute Building",
              campus: {
                title: "Cathays Park Campus",
              },
              website:
                "https://www.cardiff.ac.uk/visit/accessibility/cathays-park-campus/bute-building",
              accessible: 1,
              bike_parking: 1,
            },
            programType: { type: "Tour" },
          },
        ],
      },
    ],
  },
};
